import i18next from 'i18next';
import { UseTranslationResponse } from 'react-i18next';
import { l10nBackendModuleAzure } from './localization/localizationResourcesAzure';
import { l10nFromBackendModule } from './localization/localizationFromBackend';
import ChainedBackend from 'i18next-chained-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
export type DevLocalizationKey = Parameters<UseTranslationResponse<'dev', undefined>['t']>[0];

const DEFAULT_LANGUAGE = 'en';
enum AppLanguage {
  'en' = 'en',
  'de' = 'de',
  'fr' = 'fr',
  'es' = 'es',
  'et' = 'et',
  'it' = 'it',
  'ja' = 'ja',
  'ko' = 'ko',
  'pl' = 'pl',
  'pt' = 'pt',
  'da' = 'da',
  'el' = 'el',
  'ro' = 'ro',
  'hu' = 'hu',
  'nl' = 'nl',
  'lv' = 'lv',
  'lt' = 'lt',
  'tr' = 'tr',
  'cs' = 'cs',
  'sl' = 'sl',
  'sk' = 'sk',
  'sv' = 'sv',
  'ru' = 'ru',
  'kk' = 'kk',
  'he' = 'he',
  'ky' = 'ky',
  'th' = 'th',
  'ms' = 'ms'
}

export const APP_LANGUAGES = Object.keys(AppLanguage);

const _changeLanguageHandlers: (() => unknown)[] = [];
export function addChangeLanguageHandler(handler: () => unknown) {
  _changeLanguageHandlers.push(handler);
}

export async function changeLanguage(language: string) {
  if (!APP_LANGUAGES.includes(language)) {
    language = DEFAULT_LANGUAGE;
  }

  if (language !== i18next.language) {
    await i18next.changeLanguage(language);
    _changeLanguageHandlers.forEach(x => x?.());
  }
}

export async function integrateLocalization(): Promise<void> {
  const initPromise = i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(ChainedBackend)
    .init(
      {
        ns: ['localization', 'dev'],
        defaultNS: 'localization',
        load: 'languageOnly',
        initImmediate: false,
        lowerCaseLng: true,
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: APP_LANGUAGES,
        react: {
          useSuspense: true,
        },
        interpolation: {
          escapeValue: false, // not needed for react!!
        },
        backend: {
          backends: [l10nBackendModuleAzure(), l10nFromBackendModule()],
        },
      },
      () => {
        document.title = i18next.t('PageTitle');
      }
    );
  initPromise
    .then(() => {
      changeLanguage(i18next.language).catch(console.error);
    })
    .catch(() => {
      changeLanguage(DEFAULT_LANGUAGE).catch(console.error);
    });
}
